var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-dashboard"},[_c('TopNav'),_c('div',{staticClass:"main-container"},[_c('SideNav'),_c('div',{staticClass:"container"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }